export default __webpack_public_path__ + "static/doge-da4342518cb3be03e93d6fbf8e81d00e.png";